
import { useState } from 'react';
import { Link } from 'react-router-dom';

const QUICK_LINKS = [
  { label: 'Home',               href: '/' },
  { label: 'About Us',           href: '/about' },
  { label: 'Training Programmes',href: '/programmes' },
  { label: 'Corporate Training', href: '/corporate-training' },
  { label: 'SETA Compliance',    href: '/seta-compliance' },
  { label: 'Contact Us',         href: '/contact' },
];

const PROGRAMME_LINKS = [
  { label: 'Learnerships',              href: '/programmes' },
  { label: 'Skills Programmes',         href: '/programmes' },
  { label: 'Occupational Certificates', href: '/programmes' },
  { label: 'ETDP Training',             href: '/programmes' },
  { label: 'Short Courses',             href: '/programmes' },
  { label: 'Programme Catalogue',       href: '/resources' },
];

const CONTACT = [
  { icon: 'ri-map-pin-line',  text: 'No 6 Riboville Road, 183 Randjesfontein Country Estate, Midrand' },
  { icon: 'ri-phone-line',    text: '+27 10 224 0406',     href: 'tel:+27102240406' },
  { icon: 'ri-mail-line',     text: 'info@sylman.co.za', href: 'mailto:info@sylman.co.za' },
  { icon: 'ri-time-line',     text: 'Mon–Fri · 08:30–16:30' },
];

const BADGES = ['QCTO', 'W&RSETA', 'SAQA', 'Services SETA', 'TETA'];

const SOCIALS = [
  { icon: 'ri-linkedin-fill',  label: 'LinkedIn',  href: 'https://www.linkedin.com/company/sylman-academy' },
  { icon: 'ri-facebook-fill',  label: 'Facebook',  href: 'https://www.facebook.com/sylmanacademy' },
  { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/sylmanacademy' },
];

export default function Footer() {
  const [email,  setEmail]  = useState('');
  const [status, setStatus] = useState('');

  const subscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams({ email, formType: 'Newsletter Signup' });
      await fetch('/api/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setStatus('success');
      setEmail('');
    } catch { setStatus('error'); }
  };

  return (
    <footer className="bg-[#1A3A22] text-white border-t-2 border-[#2D7F3E]">

      {/* Main grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/0d5119b9e0bc6c06e786accc19d4f477/49d426f841df4de406c0064d2931f821.png"
              alt="Sylman Academy"
              className="h-10 w-auto mb-5 brightness-0 invert"
            />
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Empowering South African businesses through accredited skills development and SETA compliance since 2007.
            </p>
            <div className="flex gap-2">
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#2D7F3E] transition-colors"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <span className="accent-bar" />
            <h4 className="font-serif text-lg font-normal text-white mb-5">Quick Links</h4>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map(l => (
                <li key={l.href}>
                  <Link to={l.href} className="flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors group">
                    <i className="ri-arrow-right-s-line text-[#5EC97A] opacity-0 group-hover:opacity-100 transition-opacity" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programmes */}
          <div>
            <span className="accent-bar" />
            <h4 className="font-serif text-lg font-normal text-white mb-5">Programmes</h4>
            <ul className="space-y-2.5">
              {PROGRAMME_LINKS.map((l, i) => (
                <li key={i}>
                  <Link to={l.href} className="flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors group">
                    <i className="ri-arrow-right-s-line text-[#5EC97A] opacity-0 group-hover:opacity-100 transition-opacity" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + newsletter */}
          <div>
            <span className="accent-bar" />
            <h4 className="font-serif text-lg font-normal text-white mb-5">Get in Touch</h4>
            <ul className="space-y-3 mb-8">
              {CONTACT.map((c, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-white/50">
                  <i className={`${c.icon} text-[#5EC97A] mt-0.5 flex-shrink-0`} />
                  {c.href
                    ? <a href={c.href} className="hover:text-white transition-colors">{c.text}</a>
                    : <span>{c.text}</span>}
                </li>
              ))}
            </ul>

            <p className="font-serif text-base font-normal text-white/70 mb-3">Stay Updated</p>
            {status === 'success' ? (
              <p className="text-[#5EC97A] text-sm">Thanks! You're subscribed.</p>
            ) : (
              <form onSubmit={subscribe} className="flex gap-2">
                <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" className="absolute -left-[9999px]" />
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  name="email" placeholder="Your email" required
                  className="flex-1 px-3 py-2 rounded-lg bg-white/10 text-white placeholder-white/30 border border-white/10 focus:outline-none focus:border-[#5EC97A] text-sm transition-colors"
                />
                <button type="submit" className="px-4 py-2 bg-[#2D7F3E] hover:bg-[#256632] text-white rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  Join
                </button>
              </form>
            )}
            {status === 'error' && <p className="text-red-400 text-xs mt-2">Something went wrong.</p>}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col lg:flex-row justify-between items-center gap-5">
          <div className="flex flex-wrap justify-center lg:justify-start gap-2">
            {BADGES.map(b => (
              <span key={b} className="bg-white/10 border border-white/10 text-white/50 text-xs font-medium px-3 py-1 rounded-full">
                {b}
              </span>
            ))}
          </div>
          <div className="flex flex-wrap justify-center lg:justify-end items-center gap-x-5 gap-y-1 text-xs text-white/40">
            <span>© 2026 Sylman Academy · A Division of Sylman Group</span>
            <a href="#" className="hover:text-white/70 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white/70 transition-colors">Terms</a>
            <a href="#" className="hover:text-white/70 transition-colors">POPI Act</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
